export class SearchActivityHistoryItems{

  constructor(
    public searchString: string
  ) {
    this.searchString = searchString
  } 
}
